import {
  AlertTriangle,
  ShieldAlert,
  TrendingUp,
  CircleCheckBig,
} from 'lucide-react';

import {
  AtRiskKpiResponse,
} from '../../../types/Manager/atRiskAssociates.types';

type Props = {
  data: AtRiskKpiResponse | null;
  error?: string | null;
};

const AtRiskKpiCards = ({
  data,
  error,
}: Props) => {

  if (error) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 p-5 text-center">
        <p className="text-sm font-medium text-red-600">
          {error}
        </p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-5 text-center">
        <p className="text-sm text-slate-500">
          No KPI data available.
        </p>
      </div>
    );
  }

const cards = [
  {
    title: 'At Risk This Week',
    value: data.atRiskThisWeek,
    sub: `Improved from ${data.improvedFrom}`,
    color: 'bg-red-100 text-red-600',
    icon: <AlertTriangle size={16} />,
  },
  {
    title: 'Critical Risk',
    value: data.criticalRisk,
    sub: `${data.multiRiskFlagCount}+ risk flags triggered`,
    color: 'bg-orange-100 text-orange-600',
    icon: <ShieldAlert size={16} />,
  },
  {
    title: '1-on-1 Scheduled',
    value: data.oneOnOneScheduled,
    sub: `of ${data.totalAtRisk} at-risk`,
    color: 'bg-purple-100 text-purple-600',
    icon: <ShieldAlert size={16} />,
  },
  {
    title: 'Improved vs Last Wk',
    value: data.improvedLastWeek,
    sub: `${data.exitedRiskCount} exited risk list`,
    color: 'bg-blue-100 text-blue-600',
    icon: <TrendingUp size={16} />,
  },
  {
    title: 'On Track',
    value: data.onTrack,
    sub: `of ${data.totalAssociates} associates`,
    color: 'bg-green-100 text-green-600',
    icon: <CircleCheckBig size={16} />,
  },
];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">

      {cards.map((card) => (
        <div
          key={card.title}
          className="
            bg-white
            border
            border-[#d9dde3]
            rounded-[16px]
            px-4
            py-3
            h-[78px]
            flex
            items-start
            gap-3
          "
        >

          <div
            className={`
              w-8
              h-8
              rounded-full
              flex
              items-center
              justify-center
              text-[13px]
              shrink-0
              ${card.color}
            `}
          >
            {card.icon}
          </div>

          <div className="flex-1 min-w-0">

            <div className="text-[12px] font-semibold text-[#111827] leading-none truncate">
              {card.title}
            </div>

            <div className="mt-[3px] flex items-end gap-1">

              <span className="text-[16px] font-bold leading-none text-[#111827]">
                {card.value}
              </span>

            </div>

            <div className="mt-[3px] text-[9px] text-[#6b7280] leading-none">
              {card.sub}
            </div>

          </div>

        </div>
      ))}

    </div>
  );
};

export default AtRiskKpiCards;